'use client'
import { useRef } from 'react'
import { Provider } from 'react-redux'
import { makeStore, persist, store } from '@/shared/store/store'
import { PersistGate } from 'redux-persist/integration/react'

export default function StoreProvider({ children }) {
    const storeRef = useRef(undefined)
    if (!storeRef.current) {
        // Create the store instance the first time this renders
        // storeRef.current = makeStore()
    }

    return (
        <Provider store={store}>
            <PersistGate
                loading={
                    <div
                        style={{
                            width: 0,
                            height: 0,
                            visibility: 'hidden',
                            position: 'absolute',
                            top: -3000,
                        }}
                    >
                        {children}
                    </div>
                }
                persistor={persist}
            >
                {children}
            </PersistGate>
        </Provider>
    )
}
